import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { LeafFillIcon } from '@yonderland/andes-icons';
import { Tag } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { getIcon, getNewProductOverlayTagColorAndTranslationKey, getProductPriceOverlayTagColorAndContent, } from './labelsOverlay.utils';
export const useLabelsOverlay = ({ showGenderIcon, genderFeatureId, savingsPercentage, priceOverlay, showNewProductLabel, showOnlineExclusiveLabel, showSustainabilityLabel, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const aemConfiguration = useAemConfig();
    const { mainWebShop, feature_toggles: { our_planet: showOurPlanet }, } = aemConfiguration;
    const labels = [];
    const { overlayTagColor, overlayTagContent } = getProductPriceOverlayTagColorAndContent(mainWebShop, priceOverlay);
    const showGenderLabel = showGenderIcon && !!genderFeatureId && !!getIcon(genderFeatureId);
    if (showGenderLabel) {
        labels.push(_jsx(Tag, { size: "lg", testId: "gender_icon", variant: "light", icon: getIcon(genderFeatureId) }, "gender_icon"));
    }
    if (savingsPercentage && savingsPercentage > 0) {
        labels.push(_jsx(Tag, { size: "lg", variant: "sale", testId: "savings_percentage", text: `-${savingsPercentage}%` }, "dynamic_discount_label"));
    }
    if (overlayTagContent) {
        labels.push(_jsx(Tag, { size: "lg", variant: overlayTagColor, testId: "price_overlay", text: overlayTagContent }, "commercial_label"));
    }
    if (showNewProductLabel) {
        const { tagColor, translationKey } = getNewProductOverlayTagColorAndTranslationKey(mainWebShop);
        labels.push(_jsx(Tag, { size: "lg", variant: tagColor, text: t(translationKey) }, "new_product_label"));
    }
    if (showOnlineExclusiveLabel) {
        labels.push(_jsx(Tag, { size: "lg", testId: "online_exclusive", text: t('pdp.overlay.onlineexclusive') }, "online_exclusive_label"));
    }
    if (showSustainabilityLabel && showOurPlanet) {
        labels.push(_jsx(Tag, { size: "lg", variant: "sustainability", icon: LeafFillIcon, text: t('product.sustainable') }, "sustainability_label"));
    }
    return { labels };
};
